import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const AdminLogin = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('https://agro.atrmart.in/api/admin/login', formData);
      localStorage.setItem('admin_token', res.data.token);
      navigate('/admin/dashboard');
    } catch (err) {
      alert("Login Failed: Check your email and password.");
    }
  };

  return (
    <div className="admin-login-container">
      <form onSubmit={handleLogin}>
        <h2>ATR Admin Portal</h2>
        <input type="email" placeholder="Email" onChange={e => setFormData({...formData, email: e.target.value})} />
        <input type="password" placeholder="Password" onChange={e => setFormData({...formData, password: e.target.value})} />
        <button type="submit">Secure Login</button>
      </form>
    </div>
  );
};

export default AdminLogin;